import {Injectable} from '@angular/core';
import {ApiService} from '@abstract/api.service';

/**
 * API для управления документацией технического устройства
 *
 * На 2019.01.28 создание и редактирование документации происходит через API технического устройства
 * POST /api/technical-device/:id/document, чтобы сразу осуществлять связь с ТУ,
 * а вот уже удаление документации происходит через это собственное API
 */

@Injectable()
export class TechnicalDeviceDocumentApiService extends ApiService {
    baseUrl = 'technical-device-document';
}
